import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Loading } from '..';
import { errorCode } from '../../constants';
import {
  loginByPhone,
  requestOtp,
  resetAuthState,
} from '../../redux/actions/auth';
import analytic, {
  analyticEvents,
  analyticTypes,
} from '../../service/analytic';
import { generateErrorDetail } from '../../utils';

import styles from './PhoneAuthentication.module.css';

const cencorMobileNumber = (number) => {
  const numStr = number.toString();
  const showFirstNumber = 4;
  const censor = '*****';

  return (
    numStr.substring(0, showFirstNumber) +
    censor +
    numStr.substring(showFirstNumber + censor.length, numStr.length)
  );
};

const PhoneAuthentication = ({ type, onCloseModal, onGoBack }) => {
  const [step, setStep] = useState(1);
  const [mobile, setMobile] = useState();
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);
  const [startCountdown, setStartCountdown] = useState(false);
  const [resendCountdown, setResendCountdown] = useState(59);
  const interval = useRef();
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const isLogin = type === 'login';

  useEffect(() => {
    analytic(
      analyticTypes.event,
      isLogin
        ? analyticEvents.AUTH.START_LOGIN_BY_PHONE
        : analyticEvents.AUTH.START_REGISTER_BY_PHONE
    );
    analytic(
      analyticTypes.trackPage,
      isLogin ? 'LoginMobile' : 'RegisterMobile'
    );
  }, [isLogin]);

  useEffect(() => {
    return () => {
      dispatch(resetAuthState());
      resetCountdown();
    };
  }, [dispatch]);

  useEffect(() => {
    if (startCountdown) {
      interval.current = setInterval(() => {
        setResendCountdown((state) => state - 1);
      }, 1000);
    }
  }, [startCountdown]);

  useEffect(() => {
    if (resendCountdown === 0) {
      resetCountdown();
    }
  }, [resendCountdown]);

  const resetCountdown = () => {
    clearInterval(interval.current);
    setResendCountdown(59);
    setStartCountdown(false);
  };

  const handleSendOtp = async (e) => {
    e.preventDefault();
    try {
      setErr('');
      const phone = e.target.elements.phone.value;

      setLoading(true);

      await requestOtp(phone);

      setLoading(false);
      setStartCountdown(true);
      setMobile(phone);
      if (isLogin) {
        analytic(analyticTypes.trackPage, 'LoginMobileOTP');
      } else {
        analytic(analyticTypes.trackPage, 'RegisterMobileOTP');
      }

      return setStep(2);
    } catch (err) {
      const errorData = generateErrorDetail(err);
      const code = errorData.code;
      let mes = '';

      if (
        code === errorCode.INVALID_CREDENTIAL ||
        code === errorCode.INVALID_NUMBER
      ) {
        mes = 'Incorrect mobile number';
      } else if (
        code === errorCode.INVALID_PARAMETERS ||
        code === errorCode.INVALID_OTP
      ) {
        mes = 'Incorrect OTP code';
      } else if (
        code === errorCode.TOO_MANY_ATTEMPTS ||
        code === errorCode.TOO_QUICK_RETRY
      ) {
        mes = 'Too many attempts, please try again later';
      } else {
        mes = errorData.message || 'General Login Error';
      }

      setLoading(false);
      setErr(mes);
    }
  };

  const handleResendOtp = async () => {
    try {
      setLoading(true);

      await requestOtp(mobile);

      setStartCountdown(true);
      setLoading(false);
    } catch (err) {
      const errorData = generateErrorDetail(err);
      const mes = errorData.message || 'Internal Server Error!';
      setLoading(false);
      setErr(mes);
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setErr('');

    try {
      const otp = e.target.elements.otp.value;
      await dispatch(loginByPhone(mobile, otp));
      onCloseModal();
    } catch (err) {
      const errorData = generateErrorDetail(err);
      console.log(errorData);
    }
  };

  return (
    <div className={`${styles['form-wrapper']}`}>
      {step === 1 ? (
        <form id='otp-form' className={styles['form']} onSubmit={handleSendOtp}>
          <input
            type='number'
            name='phone'
            id='phone'
            placeholder='Mobile Number'
          />
          <span className={styles['default-code-number']}>+62</span>
          <span className={styles['input-placeholder']}>Mobile Number</span>
          {loading ? (
            <Loading height='100px' />
          ) : (
            <Button
              type='submit'
              style={{ width: '100%', padding: '1rem', fontWeight: 600 }}
            >
              {isLogin ? 'Login' : 'Register'}
            </Button>
          )}
        </form>
      ) : (
        <form id='login-form' className={styles['form']} onSubmit={handleLogin}>
          <span className={styles['verification']}>
            Verification code sent to
          </span>
          <span className={styles['verification-number']}>
            +62{cencorMobileNumber(mobile)}
          </span>
          <input
            type='number'
            name='otp'
            id='otp'
            maxLength='6'
            placeholder='Enter OTP Code'
          />
          <span className={styles['input-placeholder']}>Enter OTP Code</span>
          {loading ? (
            <Loading height='100px' />
          ) : (
            <>
              <Button
                type='submit'
                style={{ width: '100%', padding: '1rem', fontWeight: 600 }}
              >
                {isLogin ? 'Login' : 'Register'}
              </Button>
              <span className={styles['resend-otp']}>
                {startCountdown ? (
                  <>
                    Wait{' '}
                    <span className={styles['countdown']}>
                      {resendCountdown}
                    </span>
                    s before requesting another verification code
                  </>
                ) : (
                  <span
                    className={styles['resend-button']}
                    onClick={handleResendOtp}
                  >
                    Resend verification code
                  </span>
                )}
              </span>
            </>
          )}
        </form>
      )}

      {(!!err || !!auth.err) && <div className='error'>{err || auth.err}</div>}

      {isLogin ? (
        <div className={styles['remind']} onClick={onGoBack}>
          <span>Other Login Options</span>
        </div>
      ) : (
        <div className={styles['remind']} onClick={onGoBack}>
          <span>Other Register Options</span>
        </div>
      )}
    </div>
  );
};

export default PhoneAuthentication;
